<script>
	import { signedInUser } from '@ctm/auth/store';
	import { page } from '$app/stores';
	import { debtorSettings, permissions } from '$lib/stores/settings';
	import constants from '$lib/constants';
	import { getScoutToken as _getScoutToken } from '$lib/data/scout.js';

	function onLoad() {
		if (!window.ChatbotWidget) return;

		window.ChatbotWidget.default({
			rasaServerUrl: $debtorSettings.scoutRasaUrl,
			metadata: {
				firstName: $signedInUser.firstName,
				lastName: $signedInUser.lastName,
				name: $signedInUser.name,
				debtorId: $signedInUser.debtor,
				externalReference: $signedInUser.externalReference,
				email: $signedInUser.email,
				roleName: $signedInUser.roleTypeName,
				country: $debtorSettings.homeCountryCode,
				permissions: $permissions,
			},
			getScoutToken: async () => {
				return await _getScoutToken();
			},
		});
	}
</script>

<svelte:head>
	{#if !['/sso', '/risk-hub'].includes($page.url.pathname)}
		<script src={constants.SCOUT_SRC_URL} type="application/javascript" defer on:load={onLoad}></script>
	{/if}
</svelte:head>
